"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _createSuper = require("/app/node_modules/@babel/runtime/helpers/createSuper.js").default;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint32-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.fill.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blake2b = void 0;

var blake2 = __importStar(require("./_blake2.js"));

var u64 = __importStar(require("./_u64.js"));

var utils_js_1 = require("./utils.js"); // Same as SHA-512 but LE
// prettier-ignore


var IV = new Uint32Array([0xf3bcc908, 0x6a09e667, 0x84caa73b, 0xbb67ae85, 0xfe94f82b, 0x3c6ef372, 0x5f1d36f1, 0xa54ff53a, 0xade682d1, 0x510e527f, 0x2b3e6c1f, 0x9b05688c, 0xfb41bd6b, 0x1f83d9ab, 0x137e2179, 0x5be0cd19]); // Temporary buffer

var BUF = new Uint32Array(32); // Mixing function G splitted in two halfs

function G1(a, b, c, d, msg, x) {
  // NOTE: V is LE here
  var Xl = msg[x],
      Xh = msg[x + 1]; // prettier-ignore

  var Al = BUF[2 * a],
      Ah = BUF[2 * a + 1]; // prettier-ignore

  var Bl = BUF[2 * b],
      Bh = BUF[2 * b + 1]; // prettier-ignore

  var Cl = BUF[2 * c],
      Ch = BUF[2 * c + 1]; // prettier-ignore

  var Dl = BUF[2 * d],
      Dh = BUF[2 * d + 1]; // prettier-ignore
  // v[a] = (v[a] + v[b] + x) | 0;

  var ll = u64.add3L(Al, Bl, Xl);
  Ah = u64.add3H(ll, Ah, Bh, Xh);
  Al = ll | 0; // v[d] = rotr(v[d] ^ v[a], 32)

  var _Dh$Dl = {
    Dh: Dh ^ Ah,
    Dl: Dl ^ Al
  };
  Dh = _Dh$Dl.Dh;
  Dl = _Dh$Dl.Dl;
  var _Dh$Dl2 = {
    Dh: u64.rotr32H(Dh, Dl),
    Dl: u64.rotr32L(Dh, Dl)
  };
  Dh = _Dh$Dl2.Dh;
  Dl = _Dh$Dl2.Dl;

  var _u64$add = u64.add(Ch, Cl, Dh, Dl);

  Ch = _u64$add.h;
  Cl = _u64$add.l;
  var _Bh$Bl = {
    Bh: Bh ^ Ch,
    Bl: Bl ^ Cl
  };
  Bh = _Bh$Bl.Bh;
  Bl = _Bh$Bl.Bl;
  var _Bh$Bl2 = {
    Bh: u64.rotrSH(Bh, Bl, 24),
    Bl: u64.rotrSL(Bh, Bl, 24)
  };
  Bh = _Bh$Bl2.Bh;
  Bl = _Bh$Bl2.Bl;
  BUF[2 * a] = Al, BUF[2 * a + 1] = Ah;
  BUF[2 * b] = Bl, BUF[2 * b + 1] = Bh;
  BUF[2 * c] = Cl, BUF[2 * c + 1] = Ch;
  BUF[2 * d] = Dl, BUF[2 * d + 1] = Dh;
}

function G2(a, b, c, d, msg, x) {
  // NOTE: V is LE here
  var Xl = msg[x],
      Xh = msg[x + 1]; // prettier-ignore

  var Al = BUF[2 * a],
      Ah = BUF[2 * a + 1]; // prettier-ignore

  var Bl = BUF[2 * b],
      Bh = BUF[2 * b + 1]; // prettier-ignore

  var Cl = BUF[2 * c],
      Ch = BUF[2 * c + 1]; // prettier-ignore

  var Dl = BUF[2 * d],
      Dh = BUF[2 * d + 1]; // prettier-ignore
  // v[a] = (v[a] + v[b] + x) | 0;

  var ll = u64.add3L(Al, Bl, Xl);
  Ah = u64.add3H(ll, Ah, Bh, Xh);
  Al = ll | 0; // v[d] = rotr(v[d] ^ v[a], 16)

  var _Dh$Dl3 = {
    Dh: Dh ^ Ah,
    Dl: Dl ^ Al
  };
  Dh = _Dh$Dl3.Dh;
  Dl = _Dh$Dl3.Dl;
  var _Dh$Dl4 = {
    Dh: u64.rotrSH(Dh, Dl, 16),
    Dl: u64.rotrSL(Dh, Dl, 16)
  };
  Dh = _Dh$Dl4.Dh;
  Dl = _Dh$Dl4.Dl;

  var _u64$add2 = u64.add(Ch, Cl, Dh, Dl);

  Ch = _u64$add2.h;
  Cl = _u64$add2.l;
  var _Bh$Bl3 = {
    Bh: Bh ^ Ch,
    Bl: Bl ^ Cl
  };
  Bh = _Bh$Bl3.Bh;
  Bl = _Bh$Bl3.Bl;
  var _Bh$Bl4 = {
    Bh: u64.rotrBH(Bh, Bl, 63),
    Bl: u64.rotrBL(Bh, Bl, 63)
  };
  Bh = _Bh$Bl4.Bh;
  Bl = _Bh$Bl4.Bl;
  BUF[2 * a] = Al, BUF[2 * a + 1] = Ah;
  BUF[2 * b] = Bl, BUF[2 * b + 1] = Bh;
  BUF[2 * c] = Cl, BUF[2 * c + 1] = Ch;
  BUF[2 * d] = Dl, BUF[2 * d + 1] = Dh;
}

var BLAKE2b = /*#__PURE__*/function (_blake2$BLAKE) {
  _inherits(BLAKE2b, _blake2$BLAKE);

  var _super = _createSuper(BLAKE2b);

  function BLAKE2b() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BLAKE2b);

    _this = _super.call(this, 128, opts.dkLen === undefined ? 64 : opts.dkLen, opts, 64, 16, 16); // Same as SHA-512, but LE

    _this.v0l = IV[0] | 0;
    _this.v0h = IV[1] | 0;
    _this.v1l = IV[2] | 0;
    _this.v1h = IV[3] | 0;
    _this.v2l = IV[4] | 0;
    _this.v2h = IV[5] | 0;
    _this.v3l = IV[6] | 0;
    _this.v3h = IV[7] | 0;
    _this.v4l = IV[8] | 0;
    _this.v4h = IV[9] | 0;
    _this.v5l = IV[10] | 0;
    _this.v5h = IV[11] | 0;
    _this.v6l = IV[12] | 0;
    _this.v6h = IV[13] | 0;
    _this.v7l = IV[14] | 0;
    _this.v7h = IV[15] | 0;
    var keyLength = opts.key ? opts.key.length : 0;
    _this.v0l ^= _this.outputLen | keyLength << 8 | 0x01 << 16 | 0x01 << 24;

    if (opts.salt) {
      var salt = (0, utils_js_1.u32)((0, utils_js_1.toBytes)(opts.salt));
      _this.v4l ^= salt[0];
      _this.v4h ^= salt[1];
      _this.v5l ^= salt[2];
      _this.v5h ^= salt[3];
    }

    if (opts.personalization) {
      var pers = (0, utils_js_1.u32)((0, utils_js_1.toBytes)(opts.personalization));
      _this.v6l ^= pers[0];
      _this.v6h ^= pers[1];
      _this.v7l ^= pers[2];
      _this.v7h ^= pers[3];
    }

    if (opts.key) {
      // Pad to blockLen and update
      var tmp = new Uint8Array(_this.blockLen);
      tmp.set((0, utils_js_1.toBytes)(opts.key));

      _this.update(tmp);
    }

    return _this;
  } // prettier-ignore


  _createClass(BLAKE2b, [{
    key: "get",
    value: function get() {
      var v0l = this.v0l,
          v0h = this.v0h,
          v1l = this.v1l,
          v1h = this.v1h,
          v2l = this.v2l,
          v2h = this.v2h,
          v3l = this.v3l,
          v3h = this.v3h,
          v4l = this.v4l,
          v4h = this.v4h,
          v5l = this.v5l,
          v5h = this.v5h,
          v6l = this.v6l,
          v6h = this.v6h,
          v7l = this.v7l,
          v7h = this.v7h;
      return [v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h];
    } // prettier-ignore

  }, {
    key: "set",
    value: function set(v0l, v0h, v1l, v1h, v2l, v2h, v3l, v3h, v4l, v4h, v5l, v5h, v6l, v6h, v7l, v7h) {
      this.v0l = v0l | 0;
      this.v0h = v0h | 0;
      this.v1l = v1l | 0;
      this.v1h = v1h | 0;
      this.v2l = v2l | 0;
      this.v2h = v2h | 0;
      this.v3l = v3l | 0;
      this.v3h = v3h | 0;
      this.v4l = v4l | 0;
      this.v4h = v4h | 0;
      this.v5l = v5l | 0;
      this.v5h = v5h | 0;
      this.v6l = v6l | 0;
      this.v6h = v6h | 0;
      this.v7l = v7l | 0;
      this.v7h = v7h | 0;
    }
  }, {
    key: "compress",
    value: function compress(msg, offset, isLast) {
      this.get().forEach(function (v, i) {
        return BUF[i] = v;
      }); // First half from state.

      BUF.set(IV, 16); // Second half from IV.

      var _u64$fromBig = u64.fromBig(BigInt(this.length)),
          h = _u64$fromBig.h,
          l = _u64$fromBig.l;

      BUF[24] = IV[8] ^ l; // Low word of the offset.

      BUF[25] = IV[9] ^ h; // High word.
      // Invert all bits for last block

      if (isLast) {
        BUF[28] = ~BUF[28];
        BUF[29] = ~BUF[29];
      }

      var j = 0;
      var s = blake2.SIGMA;

      for (var i = 0; i < 12; i++) {
        G1(0, 4, 8, 12, msg, offset + 2 * s[j++]);
        G2(0, 4, 8, 12, msg, offset + 2 * s[j++]);
        G1(1, 5, 9, 13, msg, offset + 2 * s[j++]);
        G2(1, 5, 9, 13, msg, offset + 2 * s[j++]);
        G1(2, 6, 10, 14, msg, offset + 2 * s[j++]);
        G2(2, 6, 10, 14, msg, offset + 2 * s[j++]);
        G1(3, 7, 11, 15, msg, offset + 2 * s[j++]);
        G2(3, 7, 11, 15, msg, offset + 2 * s[j++]);
        G1(0, 5, 10, 15, msg, offset + 2 * s[j++]);
        G2(0, 5, 10, 15, msg, offset + 2 * s[j++]);
        G1(1, 6, 11, 12, msg, offset + 2 * s[j++]);
        G2(1, 6, 11, 12, msg, offset + 2 * s[j++]);
        G1(2, 7, 8, 13, msg, offset + 2 * s[j++]);
        G2(2, 7, 8, 13, msg, offset + 2 * s[j++]);
        G1(3, 4, 9, 14, msg, offset + 2 * s[j++]);
        G2(3, 4, 9, 14, msg, offset + 2 * s[j++]);
      }

      this.v0l ^= BUF[0] ^ BUF[16];
      this.v0h ^= BUF[1] ^ BUF[17];
      this.v1l ^= BUF[2] ^ BUF[18];
      this.v1h ^= BUF[3] ^ BUF[19];
      this.v2l ^= BUF[4] ^ BUF[20];
      this.v2h ^= BUF[5] ^ BUF[21];
      this.v3l ^= BUF[6] ^ BUF[22];
      this.v3h ^= BUF[7] ^ BUF[23];
      this.v4l ^= BUF[8] ^ BUF[24];
      this.v4h ^= BUF[9] ^ BUF[25];
      this.v5l ^= BUF[10] ^ BUF[26];
      this.v5h ^= BUF[11] ^ BUF[27];
      this.v6l ^= BUF[12] ^ BUF[28];
      this.v6h ^= BUF[13] ^ BUF[29];
      this.v7l ^= BUF[14] ^ BUF[30];
      this.v7h ^= BUF[15] ^ BUF[31];
      BUF.fill(0);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed = true;
      this.buffer32.fill(0);
      this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  }]);

  return BLAKE2b;
}(blake2.BLAKE2);
/**
 * BLAKE2b - optimized for 64-bit platforms. JS doesn't have uint64, so it's slower than BLAKE2s.
 * @param msg - message that would be hashed
 * @param opts - dkLen, key, salt, personalization
 */


exports.blake2b = (0, utils_js_1.wrapConstructorWithOpts)(function (opts) {
  return new BLAKE2b(opts);
});